module.exports = __webpack_public_path__ + "img/qr-code.33c1a164.png";